export default {
  // removing any sufficient special characters, whitespaces and line-breaks from url
  normalizeUrl(url) {
    const encodedUrl = encodeURI(url);
    const normalizedUrl = encodedUrl.replace(/%20/g, '').replace(/%0A/g, '');
    return normalizedUrl;
  },
};
